export class GoogleWorkspaceSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "primaryDomain",
            "baseName": "primaryDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "delegatedAdminEmail",
            "baseName": "delegatedAdminEmail",
            "type": "string",
            "format": "email"
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
